import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { ROLE_TYPES } from 'src/consumer/constants'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import {
  SidebarContainer,
  StyledLogo
} from './ClinicSidebarStyles'

export default function ClinicSidebar() {
  const navigate = useNavigate()
  const availableRoles = getAllRolesInBoolean()
  const { chosenRoleFlow, ownerData, assistantData } = useContext(ClinicDataContext)

  const sidebarIconSx = {
    fontSize: { xs: '30px', md: '40px' },
    color: '#fff',
  }

  return (
    <SidebarContainer>
      <StyledLogo
        src={APP_CONSTANTS.APP_LOGO_LINK}
        onError={(e) => {
          e.target.src = '/logo_brand.png'
        }}
        onClick={() => {
          if (chosenRoleFlow === ROLE_TYPES.roleClinicAssistant) {
            navigate('/ca-home')
          } else if (chosenRoleFlow === ROLE_TYPES.roleClinicOwner) {
            navigate('/clinic-home')
          }
        }}
      />
      {/* <GenericDisplayFlex
        sb
        width="100%"
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/clinic-home')}
      >
        <Home sx={sidebarIconSx} />
        <SidebarItemContainer>
          <SidebarItemText>Home</SidebarItemText>
        </SidebarItemContainer>
      </GenericDisplayFlex>

      {availableRoles?.isClinicAssistant && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/clinic-home/manage-bookings')}
        >
          <CalendarMonth sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Manage Bookings</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}

      {/* {availableRoles?.isClinicOwner && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/clinic-home/manage-workforce')}
        >
          <CalendarMonth sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Update Clinic Location Staff</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}
      {/* {(availableRoles?.isClinicOwner ||
        availableRoles.isPharmacist ||
        availableRoles.isDoctor) && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/clinic-home/pharmacy-database')}
        >
          <Medication sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Pharmacy Database</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}
      {/* {(availableRoles.isClinicOwner || availableRoles.isClinicProspect) && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/clinic-home/schedule')}
        >
          <Today sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Clinic Schedule</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}
      {/* {(availableRoles.isClinicOwner || availableRoles.isClinicProspect) && (
        <GenericDisplayFlex
          width="100%"
          sb
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/clinic-home/profile')}
        >
          <Settings sx={sidebarIconSx} />
          <SidebarItemContainer>
            <SidebarItemText>Settings</SidebarItemText>
          </SidebarItemContainer>
        </GenericDisplayFlex>
      )} */}
    </SidebarContainer>
  )
}
